export function createContact(model) {
  return {
    nickname: model.nickname,
    givenName: model.givenName,
    familyName: model.familyName,
    displayAs: model.displayAs,
    emailAddresses: model.emailAddresses,
    primaryEmail: model.primaryEmail,
    fullName: model.fullName,
    emailAddress: model.emailAddress,
    displayAsFormat: model.displayAsFormat,
    entityType: model.entityType,
    country: model.country,
    preferredLocale: model.preferredLocale,
    isClientCenterEnabled: model.isClientCenterEnabled,
    isStaffCenterEnabled: model.isStaffCenterEnabled,
    addresses: model.addresses,
    categories: [],
    isConfidential: model.isConfidential,
    phoneNumbers: model.phoneNumbers,
    socialMedia: []
  };
}
